import billQueryMonthApi from '@/api/billQueryMonth/billQueryMonthApi.js'
import moment from 'moment';

export default {
	name: 'bill-query-month',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			ftResp: {
				invoice: {
					monthList:[],
					billNoList:[]
				},
				invoiceSmall:{
					monthList:[],
					billNoList:[]
				}
			},
			monthChosen: '0',
			monthChosenSmall: '0',
			haveBill: null,
			haveBillSmall: null,
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
        this.init();
    },
	updated() {},
	beforeDestroy() {},
	methods: {
        async init(){
			this.ftResp = await billQueryMonthApi.getBillMonth();
			this.haveBill = this.ftResp && this.ftResp.invoice ? true : false;
			this.haveBillSmall = this.ftResp && this.ftResp.invoiceSmall ? true : false;
		},
		async goQueryResult(isSmall){
			var billNo = '';
			var billMonth = '';
			if(!isSmall){
				billNo = this.ftResp.invoice.billNoList[this.monthChosen]
				billMonth = this.ftResp.invoice.monthList[this.monthChosen]
			}else{
				billNo = this.ftResp.invoiceSmall.billNoList[this.monthChosenSmall]
				billMonth = this.ftResp.invoiceSmall.monthList[this.monthChosenSmall]
			}

			let monthText = this.getMonthText(billMonth);
			this.$router.push({
				name: 'bill-query-result', 
				params: {
					monthText: monthText,
					billNo: billNo,
					billMonth: billMonth
				}
			})
		},
		getMonthText(month){
			 let date = moment( month, 'YYYYMM');
			 return date._isValid? (date.format('YYYY') - 1911) + '年' + date.format('M') + '月' : monthStr;
		}
    },
};



// WEBPACK FOOTER //
// ./src/components/billQuery/billQueryMonth.js